import { c as _c } from "react/compiler-runtime";
import React, { useMemo } from 'react';
import classNames from 'classnames';
import useScreen from 'hooks/useScreen';
import ImageContentBlock from './components/ImageContentBlock';
import FixedWidthContainer from '../FixedWidthContainer';
import EmblaCarousel, { EmblaSlide } from '../image-slider-standard/components/EmblaCarousel';
const DEFAULT_BLOCK_SECTION = {};
const MultipleBlocks = t0 => {
  const $ = _c(22);
  const {
    config
  } = t0;
  const {
    imageComponent: t1,
    blockSectionConfig: t2,
    blockSection: t3
  } = config;
  const {
    size: t4
  } = t1;
  const size = t4 === undefined ? "Full Width" : t4;
  const {
    columns: t5
  } = t2;
  const columns = t5 === undefined ? 2 : t5;
  const blockSection = t3 === undefined ? DEFAULT_BLOCK_SECTION : t3;
  const {
    isMobile
  } = useScreen();
  let t6;
  if ($[0] !== blockSection) {
    t6 = Object.values(blockSection);
    $[0] = blockSection;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  let t7;
  if ($[2] !== columns || $[3] !== t6) {
    t7 = t6.slice(0, columns).filter(Boolean);
    $[2] = columns;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  const blocksArray = t7;
  const canScroll = !isMobile && columns > 4 || isMobile && columns > 2;
  const hasGaps = !isMobile && columns > 3;
  let t8;
  if ($[5] !== blocksArray || $[6] !== columns || $[7] !== hasGaps || $[8] !== isMobile) {
    t8 = blocksArray.map((blockConfig, index) => <EmblaSlide className={classNames("basis-1/2", {
      "!basis-1/3": !isMobile && columns === 3,
      "!basis-1/4": !isMobile && columns >= 4,
      "sm:pl-2.5": hasGaps,
      "sm:first:pl-0": hasGaps
    })} key={`blockSection-${blockConfig?.title?.text}-${blockConfig?.body?.text}-${index + 1}`}><ImageContentBlock blockConfig={blockConfig} /></EmblaSlide>);
    $[5] = blocksArray;
    $[6] = columns;
    $[7] = hasGaps;
    $[8] = isMobile;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const blocks = t8;
  const t9 = size === "Full Width";
  const t10 = size === "Full Page";
  let t11;
  if ($[10] !== t10 || $[11] !== t9) {
    t11 = classNames({
      "w-full max-w-none": t9,
      "max-w-[1400px]": t10
    });
    $[10] = t10;
    $[11] = t9;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  const t12 = !canScroll;
  let t13;
  if ($[13] !== t12) {
    t13 = classNames({
      "pointer-events-none": t12
    });
    $[13] = t12;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const t14 = columns < 5;
  let t15;
  if ($[15] !== blocks || $[16] !== t13 || $[17] !== t14) {
    t15 = <EmblaCarousel className={t13} variant="blog-slider" forceHideButtons={t14}>{blocks}</EmblaCarousel>;
    $[15] = blocks;
    $[16] = t13;
    $[17] = t14;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t11 || $[20] !== t15) {
    t16 = <FixedWidthContainer className={t11}>{t15}</FixedWidthContainer>;
    $[19] = t11;
    $[20] = t15;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
};
export default MultipleBlocks;